import Http from "@/utils/request.js";

//app版本更新
export function AppCheckUpdate(data){
	return Http.request({
		url: `/stock/version/getNewVersion`,
		method: 'post',
		data
	})
}